import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RandomScreeningDriverSelectionInfo extends AbstractModel {
  @autoserialize
  driverFirstName: string;

  @autoserialize
  driverLastName: string;

  @autoserialize
  complete: boolean;

  @autoserializeAs(Date)
  completedAt: Date;

  @autoserialize
  refused: boolean;

  @autoserializeAs(Date)
  notifiedAt: Date;

  @autoserialize
  notificationReceived: boolean;

  @autoserializeAs(Date)
  notificationReceivedAt: Date;

  @autoserialize
  screeningType: string;

  @autoserialize
  result: string;

  @autoserialize
  screeningId: number;

  @autoserialize
  driverId: number;

  @autoserialize
  claraPersonIdentifier: number;

  @autoserialize
  screeningStatus: string;

  @autoserialize
  randomScreeningDriverSelectionId: number;

  static OnSerialized(instance: RandomScreeningDriverSelectionInfo, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.completedAt)) {
      json.completedAt = DateUtil.serializeLocalDate(instance.completedAt);
    }

    if (!isNullOrUndefined(instance.notifiedAt)) {
      json.notifiedAt = DateUtil.serializeLocalDate(instance.notifiedAt);
    }

    if (!isNullOrUndefined(instance.notificationReceivedAt)) {
      json.notificationReceivedAt = DateUtil.serializeLocalDate(instance.notificationReceivedAt);
    }
  }

  static OnDeserialized(instance: RandomScreeningDriverSelectionInfo, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['completedAt'])) {
      instance.completedAt = DateUtil.deserializeLocalDate(json['completedAt']);
    }

    if (!isNullOrUndefined(json['notifiedAt'])) {
      instance.notifiedAt = DateUtil.deserializeLocalDate(json['notifiedAt']);
    }

    if (!isNullOrUndefined(json['notificationReceivedAt'])) {
      instance.notificationReceivedAt = DateUtil.deserializeLocalDate(json['notificationReceivedAt']);
    }
  }
}
